import { Select } from "antd";
import { debounce } from "debounce";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FILTER_ID } from ".";
import { selectRegion } from "../../../util/store/region/constants";
import { selectOneSetting } from "../../../util/store/selectors";
import { renderOpts } from "../../../util/varibles/global";
import { SiteOverviewSetting } from "../../../util/varibles/userSetting";
import { loginActions } from "../../LoginPage/reducer";
import { callEventSiteOverview, useSiteOverview } from "../SiteOverviewContext";

export const Regions = () => {
    const [value, setValue] = useState<string[] | undefined>(undefined);
    const filter = useSelector(selectOneSetting(SiteOverviewSetting.UNITS_REGIONS_FILTER));
    const regions = useSelector(selectRegion.regions);
    const [call] = useSiteOverview(state => state.unitsFilter[FILTER_ID.REGIONS]);
    const { addUnitsFilter, removeUnitsFilter } = callEventSiteOverview();
    const dispatch = useDispatch();

    const timeout = useRef(debounce((value: string[]) => {
        if (value.length === 0 || value[0] === "_") {
            removeUnitsFilter(FILTER_ID.REGIONS);
        } else {
            const ids = new Set(value);
            addUnitsFilter({ [FILTER_ID.REGIONS]: data => ids.has(data.region_id || "") })
        }
        dispatch(loginActions.updateUserSetting([{ [SiteOverviewSetting.UNITS_REGIONS_FILTER]: value }]))
    }, 350));

    useEffect(() => {
        if (call === undefined) {
            timeout.current(["_"]);
        }
    }, [call]);

    const handleChange = (id: string, checked: boolean) => {
        let value;
        if (checked) {
            if (id === "_")
                value = ["_"]
            else {
                value = [...filter, id].filter(item => item !== "_");
            }
        } else {
            value = filter.filter((item: string) => item !== id);
        }
        if (value.length === 0) {
            if (filter[0] === "-")
                return;
            value = ["_"];
        }
        setValue(value);
        timeout.current(value);
    }

    return <Select
        className='select-mode-tag'
        value={value || filter || []}
        mode='multiple'
        variant="borderless"
        placeholder="Filter by regions"
        options={[
            { value: "_", label: 'All regions' },
            ...renderOpts(regions)
        ]}
        onSelect={opt => handleChange(opt, true)}
        onDeselect={opt => handleChange(opt, false)}
    />
}

export default Regions;